<template>
  <div :class="model.background" class="py-4 md:py-8">
    <div class="container mx-auto max-w-screen-xl">
      <div class="grid grid-cols-2 gap-4 md:mx-auto md:grid-cols-6 md:gap-6">
        <div
          v-for="partner in model.partnerItems"
          :key="partner"
          class="flex h-[100px] items-center justify-center rounded-xl bg-white"
        >
          <a :href="partner.link" target="_blank">
            <VcImage :src="partner.logo" class="max-w-[100px]" :alt="partner.name" lazy />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  model: {
    type: Object,
    required: true,
  },
});
</script>
